import {getNurseFuelVar} from '@/utils/nurseFuelVar.js'
import Config from "@/config/app.js";
import { isWechat, isClient } from "@/utils/isTerminal.js";
import Storage from "good-storage";

const nurseFuelVar = getNurseFuelVar();

export function getToken() {
    let sessionToken = '';
    let userNurseLoginInfo = sessionStorage.getItem('userNurseLoginInfo');
    if (userNurseLoginInfo) {
        sessionToken = JSON.parse(userNurseLoginInfo).token || '';
    }
    let localStorageInfo = localStorage.getItem('userNurseLoginInfo');
    if (localStorageInfo) {
        sessionToken = JSON.parse(localStorageInfo).token || '';
    }
    return nurseFuelVar.token || sessionToken;
}


export function getOsVersion() {
    return nurseFuelVar.osVersion || '';
}

export function getUserId() {
    return nurseFuelVar.id || '';
}
export function iosAppIsReview() {

    return nurseFuelVar.inReview && nurseFuelVar.inReview == 1
}

function countdown(timeLength) {
    let h = parseInt(timeLength / 1000 / 60 / 60 % 24);
    let m = parseInt(timeLength / 1000 / 60 % 60);
    let s = parseInt(timeLength / 1000 % 60);
    // 个位数前补零
    h = h > 9 ? h : '0' + h;
    m = m > 9 ? m : '0' + m;
    s = s > 9 ? s : '0' + s;
    return h + ':' + m + ':' + s
}

export function initCountdown(second,callback) {
    let timeLength = second * 1000;
    let C = setInterval(_=>{
        if(timeLength <= 0){
            callback('00:00:00',0);
            clearInterval(C);
            return;
        }
        timeLength  = timeLength - 1000;
        callback(countdown(timeLength),timeLength/1000);
    },1000)
}

/*
获取当前url
http://192.168.49.71:8081/ => http://192.168.49.71:8081/
http://192.168.49.71:8081/mm/ => http://192.168.49.71:8081/mm/
http://192.168.49.71:8081/mm/index.html => http://192.168.49.71:8081/mm/
http://192.168.49.71:8081/mm/ff/login.html?id=55 => http://192.168.49.71:8081/mm/ff/

html不能能匹配除\w 的地址，也就是说你的html名字必须由a-z、A-Z、0-9，以及下划线组成才可以。
*/
export function getCurrentUrl() {
    let allUrl = window.location.href;
    let match = allUrl.match(/(\S+\/)\w+.html/i);
    return (match && Array.isArray(match) && (match.length > 1)) ? match[1] : allUrl;
}

export function getOpenId() {
    return localStorage.getItem("UserOpenId");
}

export function setOpenId(openID) {
    return localStorage.setItem("UserOpenId",openID) || "";
}

/**
 * 获取当前的日期时间 格式“yyyy-MM-dd HH:MM:SS”
 */
export  function getNowFormatDate () {
    let date = new Date();
    let seperator1 = "-";
    let seperator2 = ":";
    let month = date.getMonth() + 1;
    let strDate = date.getDate();
    if (month >= 1 && month <= 9) {
        month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
    }
    let hours = date.getHours();
    if(hours >=0 && hours <=9){
        hours = "0" + hours;
    }
    let minutes = date.getMinutes();
    if(minutes >=0 && minutes <=9){
        minutes = "0" + minutes;
    }
    let seconds = date.getSeconds();
    if(seconds >=0 && seconds <=9){
        seconds = "0" + seconds;
    }
    let currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate
      + " " + hours + seperator2 + minutes
      + seperator2 + seconds;
    return currentdate;
}


export function adjustMobileBrand () {
    // let navigator.userAgent.toLowerCase()
    const sUserAgent = window.navigator.userAgent.toLowerCase();
    console.log("sUserAgent", sUserAgent)
    let isIphone = sUserAgent.match(/iphone/i) == "iphone";
    let isHuawei = sUserAgent.match(/huawei/i) == "huawei";
    let isHonor = sUserAgent.match(/honor/i) == "honor";
    let isOppo = sUserAgent.match(/oppo/i) == "oppo";
    let isOppoR15 = sUserAgent.match(/pacm00/i) == "pacm00";
    let isVivo = sUserAgent.match(/vivo/i) == "vivo";
    let isXiaomi = sUserAgent.match(/mi\s/i) == "mi ";
    let isXiaomi2s = sUserAgent.match(/mix\s/i) == "mix ";
    let isRedmi = sUserAgent.match(/redmi/i) == "redmi";
    let isSamsung = sUserAgent.match(/sm-/i) == "sm-";
    let isHuaweiP20 = sUserAgent.match(/huaweieml/i) == "huaweieml";
    let isHuaweiP20Pro = sUserAgent.match(/huaweiclt/i) == "huaweiclt";

    if (isHuaweiP20 || isHuaweiP20Pro) {
        return 'huaweiP20';
    } else if (isIphone) {
        return 'iphone';
    } else if (isHuawei) {
        return 'huawei';
    } else if (isHonor) {
        return 'honor';
    } else if (isOppo || isOppoR15) {
        return 'oppo';
    } else if (isVivo) {
        return 'vivo';
    } else if (isXiaomi || isRedmi || isXiaomi2s) {
        return 'xiaomi';
    } else if (isSamsung) {
        return 'samsung';
    } else {
        return 'default';
    }
}

/**
 * 获取用户信息
 * @param key
 * @returns {null|*|undefined|{}}
 */
 export function getUserInfo(key = null) {
    if (isClient) {
      return getNurseFuelVar(key);
    }
    let userInfo = Storage.get(Config.userInfoKey) || {};
    if (key) return userInfo.hasOwnProperty(key) ? userInfo[key] : null;
    return userInfo || {};
  }

  export function isUserSource() {
    let userSource = "";
    if (isClient) {
      userSource = "APP";
    } else if (isWechat) {
      userSource = "WX";
    } else {
      userSource = "OTHER";
    }
    return userSource;
  }
  //如果文章内容没用任何中午的话，去除里面的p标签和br标签
  export function delGapTab(articleContent){
      let reg = new RegExp("[\\u4E00-\\u9FFF]+","g");
      let a = articleContent
      if(!reg.test(articleContent)){//没有任何中文
          a = a.replace(/<p>/g,"")
          a = a.replace(/<\/p>/g,"")
          a = a.replace(/<br>/g,"")
      }
      return a
  }

export function deviceInfo() {
    if (isClient) return "APP";
    let userAgentInfo = navigator.userAgent;
    let Agents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod"
    ];
    let flag = "PC";
    for (let v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = "PHONE";
            break;
        }
    }
    return flag;
}